export function RandomRangeInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function RandomRangeFloat(min: number, max: number) {
    return Math.random() * (max - min) + min;
}

export function RandomBoolean() {
    return Math.random() < 0.5;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/math/random.ts